import { Permission } from 'extra/types/Permissions'
import { ExecutionsList } from '../components/ExecutionsList'
import { RequirePermission } from '../components/RequirePermission'

export function ExecutionsPage () {
  return (
    <RequirePermission
      permission={Permission.VIEW_EXECUTIONS}
      fallback={
        <div className="flex flex-col items-center justify-center py-16">
          <p className="text-gray-400 text-lg">You do not have permission to view executions.</p>
        </div>
      }
    >
      <div className="flex flex-col">
        <div className="flex items-center justify-between mb-2">
          <h1 className="text-2xl font-bold text-white">Executions</h1>
        </div>
        <div className="border border-gray-800 rounded-lg bg-gray-900">
          <ExecutionsList />
        </div>
      </div>
    </RequirePermission>
  )
}
